import { useEffect } from 'react';

/**
 * Hook to listen for the dev tools keyboard shortcut.
 * Mac: Ctrl + Option + Cmd + Space
 * Windows/Linux: Ctrl + Alt + Shift + Space
 */
export const useDevToolsShortcut = (onTrigger: () => void) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;

      if (isMac) {
        if (event.ctrlKey && event.altKey && event.metaKey && event.code === 'Space') {
          event.preventDefault();
          onTrigger();
        }
      } else {
        if (event.ctrlKey && event.altKey && event.shiftKey && event.code === 'Space') {
          event.preventDefault();
          onTrigger();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onTrigger]);
};
